var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm"}},[_c('button',{staticClass:"btn btn-fill mt-2 btn-block btn-primary",attrs:{"disabled":!_vm.checkAccepted},on:{"click":_vm.inviteSubmit}},[_vm._v("\n         "+_vm._s(_vm.$t("NEXT"))+"\n      ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }